<template>
  <div class="address-manage">
    <div class="section-title">地址管理</div>

    <!-- 新增地址按钮 -->
    <div class="add-address" @click="handleAddAddress">
      <div class="add-icon">
        <i class="el-icon-plus"></i>
      </div>
      <div class="add-text">添加新地址</div>
    </div>

    <!-- 地址列表 -->
    <div class="address-list" v-if="false">
      <!-- 后续添加地址列表 -->
    </div>
    <empty-component v-else text="暂无收货地址，请添加~"></empty-component>

    <!-- 新增/编辑地址弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="addressForm" :rules="rules" ref="addressForm" label-width="100px">
        <el-form-item label="收货人" prop="name">
          <el-input v-model="addressForm.name" placeholder="请输入收货人姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="addressForm.mobile" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="所在地区" prop="region">
          <el-cascader v-model="addressForm.region" :options="regionOptions" placeholder="请选择所在地区"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input type="textarea" v-model="addressForm.address" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等"></el-input>
        </el-form-item>
        <el-form-item label="设为默认" prop="isDefault">
          <el-switch v-model="addressForm.isDefault"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'AddressManage',
  components: {
    EmptyComponent
  },
  data() {
    // 手机号验证规则
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      dialogTitle: '新增收货地址',
      submitLoading: false,
      addressForm: {
        name: '',
        mobile: '',
        region: [],
        address: '',
        isDefault: false
      },
      rules: {
        name: [
          { required: true, message: '请输入收货人姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        region: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
          { min: 5, max: 100, message: '长度在 5 到 100 个字符', trigger: 'blur' }
        ]
      },
      regionOptions: [] // 这里需要添加省市区数据
    }
  },
  methods: {
    handleAddAddress() {
      this.dialogTitle = '新增收货地址'
      this.addressForm = {
        name: '',
        mobile: '',
        region: [],
        address: '',
        isDefault: false
      }
      this.dialogVisible = true
    },
    async handleSubmit() {
      try {
        await this.$refs.addressForm.validate()
        this.submitLoading = true
        // TODO: 调用新增地址接口
        this.$message.success('添加成功')
        this.dialogVisible = false
      } catch (error) {
        console.log(error)
      } finally {
        this.submitLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.address-manage {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: left;
  }

  .add-address {
    width: 240px;
    height: 160px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;
    margin-bottom: 20px;

    &:hover {
      border-color: #409eff;
      .add-icon {
        color: #409eff;
      }
      .add-text {
        color: #409eff;
      }
    }

    .add-icon {
      font-size: 32px;
      color: #999;
      margin-bottom: 10px;
    }

    .add-text {
      font-size: 14px;
      color: #999;
    }
  }

  :deep(.el-cascader) {
    width: 100%;
  }
}
</style>
